import styled from 'styled-components'

export const LoadingTablePlaceholderWrapper = styled.div`
  padding: 140px 0px;
`
